<h1 mat-dialog-title>Find Product</h1>
<mat-dialog-content class="mat-typography">
  <div class="form-container">
    <form [formGroup]="form.formGroup">
      <app-product-select [form]="form" [hideNotInStock]="false" (productChange)="setProduct($event)" />
    </form>
  </div>

  @if (product) {
    <div class="mobile-only">
      <div class="mt-3">
        <p>
          <strong>{{ product.productCategoryName }}</strong>
        </p>

        <p>{{ product.name }}</p>
      </div>

      <div class="text-end">
        <button mat-raised-button (click)="openProductCategory(product)" color="primary">View Product Category</button>
      </div>
    </div>
  }
</mat-dialog-content>
